/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MailChimpStatusResponse } from '../../models/mail-chimp-status-response';

export interface ChangeNewsletterStatus$Params {
}

export function changeNewsletterStatus(http: HttpClient, rootUrl: string, params?: ChangeNewsletterStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<MailChimpStatusResponse>> {
  const rb = new RequestBuilder(rootUrl, changeNewsletterStatus.PATH, 'post');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MailChimpStatusResponse>;
    })
  );
}

changeNewsletterStatus.PATH = '/rest/user/newsletter';
